export const deleteEmptyProperties = (obj: any): any => {
  if (obj !== null && typeof obj === 'object') {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (
          obj[key] === null || obj[key] === undefined || obj[key] === '' ||
          (Array.isArray(obj[key]) && obj[key].length === 0) ||
          (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0)
        ) {
          delete obj[key]
        } else {
          obj[key] = deleteEmptyProperties(obj[key])
          if (
            (Array.isArray(obj[key]) && obj[key].length === 0) ||
            (typeof obj[key] === 'object' && Object.keys(obj[key]).length === 0)
          ) {
            delete obj[key]
          }
        }
      }
    }
  }

  return obj
}
